import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {Alert,Button } from 'antd';
import { alertService, AlertType } from '../../services';

const propTypes = {
    id: PropTypes.string,
    fade: PropTypes.bool
};

const defaultProps = {
    id: 'default-alert',
    fade: true
};

function DisplayAlert({ id, fade }:any) {
    const history = useHistory();
    
    const [alerts, setAlerts] = useState<any[]>([]);

    useEffect(() => {
        // subscribe to new alert notifications
        const subscription = alertService.onAlert(id)
            .subscribe((alert:any) => {
                // clear alerts when an empty alert is received
                if (!alert.message) {
                    setAlerts(alerts => {
                        // filter out alerts without 'keepAfterRouteChange' flag
                        const filteredAlerts = alerts.filter((x:any) => x.keepAfterRouteChange);

                        // remove 'keepAfterRouteChange' flag on the rest
                        filteredAlerts.forEach((x:any) => delete x.keepAfterRouteChange);
                        return filteredAlerts;
                    });
                } else {
                    // add alert to array
                    setAlerts(alerts => ([...alerts, alert]));

                    // auto close alert if required
                    if (alert.autoClose) {
                        setTimeout(() => removeAlert(alert), 3000);
                    }
                }
            });

        // clear alerts on location change
        const historyUnlisten = history.listen(({ pathname }) => {
            // don't clear if pathname has trailing slash because this will be auto redirected again
            if (pathname.endsWith('/')) return;

            alertService.clear(id);
        });

        // clean up function that runs when the component unmounts
        return () => {
            // unsubscribe & unlisten to avoid memory leaks
            subscription.unsubscribe();
            historyUnlisten();
        };
    }, []);

    function removeAlert(alert:any) {
        if (fade) {
            // fade out alert
            const alertWithFade = { ...alert, fade: true };

            setAlerts(alerts => alerts.map(x => x === alert ? alertWithFade : x));

            // remove alert after faded out
            setTimeout(() => {
                setAlerts(alerts => alerts.filter(x => x !== alertWithFade));
            }, 250);
        } else {
            // remove alert
            setAlerts(alerts => alerts.filter(x => x !== alert));
        }
    }

    function cssClasses(alert:any) {
        if (!alert) return;

        const classes = ['alert', 'alert-dismissable'];
                
        const alertTypeClass = {
            [AlertType.Success]: 'alert alert-success',
            [AlertType.Error]: 'alert alert-danger',
            [AlertType.Info]: 'alert alert-info',
            [AlertType.Warning]: 'alert alert-warning'
        }

        classes.push(alertTypeClass[alert.type]);

        if (alert.fade) {
            classes.push('fade');
        }

        return classes.join(' ');
    }

    if (!alerts.length) return null;

    return (
    //     <div className="container">
    //     <div className="m-3">
    //         {alerts.map((alert, index) =>
    //             <div key={index} className={cssClasses(alert)}>
    //                 <Alert key={index}
    //   message="Error Text"
    //   showIcon
    //   description={alert.message}
    //   type={alert.type.toLowerCase()}
      
    // />
    //                 <a className="close" onClick={() => removeAlert(alert)}>&times;</a>
    //                 <span dangerouslySetInnerHTML={{__html: alert.message}}></span>
    //             </div>
    //         )}
    //     </div>
    // </div>
         <div >
             {alerts.map((alert, index) =>
                 <Alert key={index} message={alert.header} showIcon 
                    description={alert.message}
                    type={alert.type.toLowerCase()}
      
    />                       
            )}
         </div>
    );
}

DisplayAlert.propTypes = propTypes;
DisplayAlert.defaultProps = defaultProps;
export default  DisplayAlert ;